module.exports = __webpack_public_path__ + "static/media/slide2.55c3338c.jpg";